import type { Transition } from '@uirouter/angularjs';

export const errorPageState = {
	name: 'errorState',
	component: 'mxShellErrorMessage',
	data: {
		isAnonymous: true,
	},
	params: {
		error: '',
		errorTitle: '',
	},
	resolve: {
		error: ['$transition$', async ($transition$: Transition) => $transition$.params().error],
		errorTitle: ['$transition$', async ($transition$: Transition) => $transition$.params().errorTitle],
	},
};
